import React, { useEffect, useState } from 'react';
import Autocomplete from '@material-ui/lab/Autocomplete';
import Grid from '@material-ui/core/Grid';
import TextField from '@material-ui/core/TextField';
import ScannerIcon from "@material-ui/icons/Scanner";
import Save from "@material-ui/icons/Save";

import {
    useStylesUp, useStylesHed, useStylesAuto, useStylesAutoPurch, useStylesTF, useStylesTD, useStylesBA, useStylesLbl
    , useStylesUiElemment,
    useStylesSpDial,
    useStylesAutoSafe,
} from '../../../../St/Reports/UseStyle';
import { Box, Button, colors, Container, Hidden, IconButton, Paper } from '@material-ui/core';
import { useTranslation } from "react-i18next";
import KeyboardReturnSharpIcon from "@material-ui/icons/KeyboardReturnSharp";
import { insh as inshst } from "../../../../Context/InshSt";
import { getoptionlblItem } from '../SarfTwreed/SarfTwreedForm';
import { Search } from '@material-ui/icons';

export default function SafesTransfersForm(props) {
    const { t } = useTranslation(["forms", "translation"]);

    const {
        AutoOptions,
        rptParamsSub,
        onChangeDataSub,
        onChangeAutoDataSubunit,
        valueAutosSub,
        selectItems,
        unitsOptions,
        onChangeBarcodeSearch,
        onChangeAutoDataSubCurr,
        onSubmit,
        onChangeDataSubQ,
        onChangeDataSubP,
        MathChangIdata,
        editing,
        handleInputSearch,
        optionsItemsSearch,
        searchText,
        handleIconSearch
    } = props;

    const clasup = useStylesUp();
    const calsPurch = useStylesAutoPurch();
    const claslbl = useStylesLbl();
    const clasAo = useStylesAuto();
    const clasTF = useStylesTF();
    const clasui = useStylesUiElemment();

    const handleFocus = (e) => e.target.select();
    const clasSaf = useStylesAutoSafe();

    return (
        <React.Fragment className="notranslate">

            <Grid container style={{ padding: 5 }} spacing={1}
                className="notranslate">
                <Grid item lg={2} md={2} sm={2} xs={3} style={{ paddingBottom: "0.5rem" }}>
                    <TextField
                        type="text"
                        fullWidth
                        variant="outlined"
                        size="small"
                        id="barcode"
                        label={t("forms:barcode")}
                        style={{ backgroundColor: colors.blue[50], marginBlock: 5 }}
                        name="barcode"
                        value={rptParamsSub.barcode}
                        autoFocus={true}
                        InputProps={{
                            onKeyDown: (event) => {
                                if (event.key === 'Enter') {
                                    onChangeBarcodeSearch(event);
                                    document.getElementById("val1").focus();
                                }
                            },
                        }}
                        onFocus={handleFocus}

                        onChange={onChangeDataSub("barcode")}
                    />
                </Grid>

                <Grid item lg={2} md={2} sm={3} xs={6} style={{ paddingBottom: "0.5rem" }}>
                    <Autocomplete
                        classes={clasSaf}
                        value={valueAutosSub.curr}
                        id="combo-box-demo"
                        onInputChange={(event, newValue, reason) => {
                            if (reason === "input") handleInputSearch(event, newValue, reason);
                        }}
                        // onInputChange={handleInputSearch}
                        options={optionsItemsSearch ?? []}
                        noOptionsText={t("search_item")}
                        getOptionLabel={(option) =>
                            getoptionlblItem(option)
                        }
                        disableClearable
                        disabled={editing}
                        style={{ backgroundColor: colors.blue[50], marginBlock: 5 }}
                        fullWidth
                        variant="outlined"
                        size="small"
                        autoFocus={false}
                        renderInput={(params) => (
                            <Box ize="small" display={"flex"} textAlign={"center"}>
                                <TextField
                                    {...params}
                                    label={t("search_item")}
                                    variant="outlined"
                                    fullWidth
                                    size="small"
                                    textAlign={"center"}
                                    id="searchItemName3"
                                    InputLabelProps={{ className: claslbl.clrBlackLblS }}
                                />
                                {searchText != "" && (
                                    <IconButton size="small" onClick={handleIconSearch}>
                                        <Search />
                                    </IconButton>
                                )}
                            </Box>
                        )}
                        onChange={(event, newValue) => {
                            onChangeAutoDataSubCurr("curr", newValue);
                            document.getElementById("val1").focus();
                        }}

                    />
                </Grid>
                <Grid item lg={2} md={2} sm={3} xs={3} style={{ paddingBottom: "0.5rem" }}>
                    <Autocomplete
                        value={valueAutosSub.units}
                        labelPlacement=""
                        onChange={(event, newValue) => {
                            onChangeAutoDataSubunit("units", newValue);
                            document.getElementById("val1").focus();
                        }}
                        id="units"
                        size="small"
                        disabled={selectItems}
                        style={{ backgroundColor: colors.blue[50], marginBlock: 5 }}
                        options={unitsOptions}
                        getOptionLabel={(option) =>
                            typeof option === "string" ? option : option.unitName
                        }
                        renderInput={(params) => (
                            <TextField
                                {...params}
                                label={t("unit")}
                                variant="outlined"
                                size="small"
                            />
                        )}
                    />
                </Grid>

                <Grid item lg={1} md={1} sm={2} xs={3} style={{ paddingBottom: "0.5rem" }}>
                    <TextField fullWidth variant="outlined" size="small"
                        id="val1"
                        label={t("quanity")}
                        className={clasTF.rootSafe}
                        style={{ backgroundColor: colors.blue[50], marginBlock: 5 }}
                        onFocus={handleFocus}
                        InputProps={{
                            className: claslbl.clrSafe,
                            onKeyDown: (event) => {
                                if (event.key === 'Enter') {
                                    document.getElementById("price").focus();
                                }
                            },
                        }}
                        type="number"
                        name="val1" value={rptParamsSub.val1} onChange={onChangeDataSubP('val1')}
                    />
                </Grid>
                <Grid item lg={1} md={1} sm={2} xs={3} style={{ paddingBottom: "0.5rem" }}>
                    <TextField fullWidth variant="outlined" size="small"
                        id="qty_balance"
                        label={t("quantity-available")}

                        className={clasTF.rootSafe}
                        style={{ backgroundColor: colors.blue[50], marginBlock: 5 }}

                        InputProps={{ className: claslbl.clrSafe, readOnly: true }}
                        type="number"
                        name="qty_balance" value={rptParamsSub.qty_balance}
                    />
                </Grid>
                <Grid item lg={1} md={1} sm={2} xs={3} style={{ paddingBottom: "0.5rem" }}>
                    <TextField fullWidth variant="outlined" size="small"
                        id="qty_balance"
                        label={t("unit-balance")}
                        className={clasTF.rootSafe}
                        style={{ backgroundColor: colors.blue[50], marginBlock: 5 }}
                        InputProps={{ className: claslbl.clrSafe, readOnly: true }}
                        type="number"
                        name="unit_balance" value={rptParamsSub.unit_balance}
                    />
                </Grid>
                <Grid item lg={1} md={1} sm={2} xs={3} style={{ paddingBottom: "0.5rem" }}>
                    <TextField fullWidth variant="outlined" size="small"
                        id="price"
                        label={t("price")}
                        style={{ backgroundColor: colors.blue[50], marginBlock: 5 }}
                        onFocus={handleFocus}
                        className={clasTF.rootSafe}
                        InputProps={{
                            className: claslbl.clrSafe,
                            onKeyDown: (event) => {
                                if (event.key === 'Enter') {
                                    onSubmit(event);
                                    document.getElementById("barcode").focus();
                                }
                            },
                        }}
                        type="number"
                        name="refno" value={rptParamsSub.price} onChange={onChangeDataSubP('price')}
                    />
                </Grid>

                <Grid item lg={2} md={2} sm={2} xs={2} style={{ paddingBottom: "0.5rem" }}>

                    <Container
                        maxWidth={false}
                        style={{
                            padding: "5px",
                        }}
                    >

                        <Hidden smUp={["sm"]}>

                            <Grid item>
                                <Button
                                    // disabled={fetching}
                                    variant="contained"
                                    startIcon={<Save />}
                                    size="small"
                                    style={
                                        (inshst.safe.iconBtn,
                                            { borderRadius: 0, backgroundColor: "#3f51b5" })
                                    }
                                    className={[clasui.button]}
                                    onClick={onSubmit}

                                // onClick={() => addItemsList(rptParamsSub)}
                                >
                                    {editing ? t("update") : t("download")}
                                </Button>
                            </Grid>
                        </Hidden>
                        <Hidden only={["xs"]}>

                            <Grid item>
                                <Button
                                    // disabled={false}
                                    variant="contained"
                                    startIcon={<Save />}
                                    size="large"
                                    style={
                                        (inshst.sal.iconBtn,
                                            { borderRadius: 0, backgroundColor: "#3f51b5" })
                                    }
                                    className={[clasui.button]}
                                    // onClick={() => addItemsList(rptParamsSub)}
                                    onClick={onSubmit}

                                >
                                    {editing ? t("edit-item") : t("download-item")}
                                </Button>
                            </Grid>
                        </Hidden>

                    </Container>

                </Grid>
            </Grid>

        </React.Fragment >
    );

}